import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import GlobalPartner from "./sections/GlobalPartner";
import OurExpertise from "./sections/OurExpertise";
import Sourcingexpertise from "./sections/Sourcingexpertise";
import Process from "./sections/Process";
import ClinicalValidation from "./sections/ClinicalValidation";
import Partnervalue from "./sections/Partnervalue";
import Transformation from "./sections/Transformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <GlobalPartner />
      <OurExpertise />
      <Sourcingexpertise />
      <Process />
      <ClinicalValidation />
      <Partnervalue />
      <Transformation />
      <Footer />
    </div>;
}